import { is } from 'stdlib/is'

/** Támogatott az IntersectionObserver? */
export default function isIntersectionObserverSupported (): boolean {
  return is.property(window, 'IntersectionObserver')
}
